document.addEventListener('DOMContentLoaded', () => iniciarApp());

function iniciarApp(){
    menu();
    darkMode();
    idiomas();
    descargarCV();
}

function menu(){
    const nav = document.querySelector('.navegacion');
    const listaNav = document.querySelector('.navegacion ul');
    const home = document.querySelector('.home');
    const footer = document.querySelector('.footer');
    const menuIcon = document.querySelector('.menu');

    nav.classList.add('productos-nav');
    listaNav.classList.add('ocultar-nav');
    home.classList.add('ocultar-nav');
    footer.classList.add('padding-top-7');

    menuIcon.addEventListener('click', () => {
        const nav = document.querySelector('.navegacion');
        const nav2 = document.querySelector('.navegacion-oculta');
        
        nav.classList.toggle('productos-nav-click');
        nav2.classList.toggle('ocultar-nav');
    });
}

function idiomas(){
    const btnCambiarIdioma = document.querySelector('.btn-cambiar');
    btnCambiarIdioma.addEventListener('click', () => {
        const opcionesIdiomas = document.querySelector('ul.idiomas-nav');
        opcionesIdiomas.classList.toggle('mostrar-idiomas');
        btnCambiarIdioma.classList.toggle('btn-cambiar-active');
        cambiarIdioma();
    });
}

function cambiarIdioma(){
    const idiomas = document.querySelectorAll('li.idioma');
    idiomas.forEach(idioma => {
        idioma.addEventListener('click', e => {
            if(idioma.children[1].dataset.idioma == 'es'){
                setCookieIdioma('es');
            }else if(idioma.children[1].dataset.idioma == 'en'){
                setCookieIdioma('en');
            }else if(idioma.children[1].dataset.idioma == 'de'){
                setCookieIdioma('de');
            }else{
                setCookieIdioma('es');
            }
            window.location.reload();
        });
    });
}

function setCookieIdioma(idioma){
    document.cookie = `language=${idioma};expires=` + new Date(new Date().getTime() + 3600 * 1000).toUTCString();
}

function darkMode(){
    // const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const darkModeButton = document.querySelector('.darkmode-button');
    darkModeButton.addEventListener('click', () =>{
        const darkmode = document.body.classList.contains('dark-mode') ? false : true;
        document.body.classList.toggle("dark-mode");
        document.cookie = `dark-mode=${darkmode};expires=` + new Date(new Date().getTime() + 3600 * 1000).toUTCString();
    });
}

function descargarCV(){
    const btnCV = document.querySelector('.btn-cv');
    btnCV.addEventListener('click', (e) => {
        e.preventDefault();
        const opcionesDIV = document.querySelector('.opcionesDIV');
        opcionesDIV.classList.toggle('mostrarOpcionesCV');
        btnCV.classList.toggle('activeOpcionesCV');
        const opciones = document.querySelectorAll('.opcionesDIV li');
        opciones.forEach(opcion => {
            opcion.addEventListener('click', e => {
                opcionesDIV.classList.remove('mostrarOpcionesCV');
                btnCV.classList.remove('activeOpcionesCV');
                if(e.target.dataset.idioma === 'es'){
                    window.open('/archivos/CV.pdf', '_blank');
                }else if(e.target.dataset.idioma === 'en'){
                    window.open('/archivos/CV-EN.pdf', '_blank');
                }
            });
        });

    });
}